import { ISmartFieldRenderProps } from "@components/smart/smartField/SmartField";
import { ISmartFieldEvents } from "@components/smart/smartField/SmartFieldUtils";
import BindingContext from "@odata/BindingContext";
import MonthCheckboxSelector from "@pages/payroll/Eldp/MonthCheckboxSelector";
import React, { useCallback } from "react";
import TestIds from "../../../testIds";

interface IProps extends Omit<ISmartFieldRenderProps, "onBlur" | "onChange" | "onRowsChange">, ISmartFieldEvents {
    hideMasterCheckbox?: boolean;
    bindingContext?: BindingContext;
}

const SmartMonthCheckboxSelector: React.FC<IProps> = ({
                                                          info,
                                                          bindingContext,
                                                          onChange,
                                                          value,
                                                          hideMasterCheckbox
                                                      }) => {

    const handleChange = useCallback((newValue: string) => {
        onChange({
            value: newValue,
            bindingContext: bindingContext ?? info.bindingContext,
            previousValue: value
        });
    }, [info.bindingContext, bindingContext, onChange, value]);

    return (
        <MonthCheckboxSelector value={value}
                               hideMasterCheckbox={hideMasterCheckbox}
                               onChange={handleChange}
                               name={info.id}/>
    );
};

export default SmartMonthCheckboxSelector;